export default "__VITE_ASSET__ec629f71__"